import { Handle, Position } from "reactflow";
import { Button } from "@components/Input";

import { useFlowNodes } from "../../../../../context";
import { nodesExist } from "../../../../utils/hasNodes";
import { addNode } from "../../../../utils/addNode";

import "./ButtonAddParams.scss";

export const ButtonAddParams = (dataNode, id) => {
  const { t, updateElement, intent, nodes, setNodes, setEdges } =
    useFlowNodes();

  return (
    <>
      <Handle type="target" position={Position.Left} />
      <Handle type="source" id={id} position={Position.Right} />
      <div>
        <Button
          className="button-add-params-container"
          type={"dashed"}
          onClick={(e) => {
            updateElement(e, "parameters", "add");
            addNode({
              nodesExist: nodesExist({
                nodes,
                parentId: dataNode.data.parentData.id,
              }),
              setNodes,
              setEdges,
              dataNode,
              type: "ParameterConfigIntentNode",
              dataInfo: {
                indexParam: intent.parameters.length - 1,
              },
            });
          }}
          text={t("intents.config.accordion.params.button")}
        />
      </div>
    </>
  );
};
